import { X, AlertTriangle, Check, Send, PackageCheck } from "lucide-react";

import type { PurchaseOrdersViewState } from "./purchase-order-view-state";
import { PurchaseOrderCancelFields } from "./PurchaseOrderCancelFields";
import { PurchaseOrderQualityFields } from "./PurchaseOrderQualityFields";
import { PurchaseOrderReceiveFields } from "./PurchaseOrderReceiveFields";
import { PurchaseOrderSendFields } from "./PurchaseOrderSendFields";
import { PurchaseOrderCreateFields } from "./PurchaseOrderCreateFields";
type Props = Pick<PurchaseOrdersViewState,
  | "dialog"
  | "submitting"
  | "setDialog"
  | "operationError"
  | "isRolePreview"
  | "dispatchRecipient"
  | "deliveryAddress"
  | "setDeliveryAddress"
  | "expectedQuantity"
  | "setExpectedQuantity"
  | "quantity"
  | "setQuantity"
  | "returnQuantity"
  | "setReturnQuantity"
  | "deliveredAt"
  | "setDeliveredAt"
  | "deliveryNoteNo"
  | "setDeliveryNoteNo"
  | "returnDisposition"
  | "setReturnDisposition"
  | "returnReason"
  | "setReturnReason"
  | "deliveryDocument"
  | "chooseDeliveryDocument"
  | "setDeliveryDocument"
  | "note"
  | "setNote"
  | "qualityStatus"
  | "setQualityStatus"
  | "qualityNote"
  | "setQualityNote"
  | "qualityDisposition"
  | "setQualityDisposition"
  | "canSubmit"
  | "submit">;

export function PurchaseOrderDialog({
  dialog,
  submitting,
  setDialog,
  operationError,
  isRolePreview,
  dispatchRecipient,
  deliveryAddress,
  setDeliveryAddress,
  expectedQuantity,
  setExpectedQuantity,
  quantity,
  setQuantity,
  returnQuantity,
  setReturnQuantity,
  deliveredAt,
  setDeliveredAt,
  deliveryNoteNo,
  setDeliveryNoteNo,
  returnDisposition,
  setReturnDisposition,
  returnReason,
  setReturnReason,
  deliveryDocument,
  chooseDeliveryDocument,
  setDeliveryDocument,
  note,
  setNote,
  qualityStatus,
  setQualityStatus,
  qualityNote,
  setQualityNote,
  qualityDisposition,
  setQualityDisposition,
  canSubmit,
  submit,
}: Props) {
  return (<>{dialog ? (
    <section
      className="form-modal-surface purchase-order-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="purchase-order-modal-title"
      aria-busy={submitting}
    >
      <div className="section-heading compact">
        <div>
          <span className="section-kicker">
            {dialog.kind === "create"
              ? "ONAYLI KARAR"
              : dialog.kind === "send"
                ? "TEDARİKÇİ İLETİMİ"
                : dialog.kind === "receive"
                  ? "YAPILANDIRILMIŞ MAL KABUL"
                  : dialog.kind === "quality"
                    ? "KALİTE KONTROLÜ"
                    : "KONTROLLÜ İPTAL"}
          </span>
          <h2 id="purchase-order-modal-title">
            {dialog.kind === "create"
              ? "Sipariş oluştur"
              : dialog.kind === "send"
                ? "Tedarikçiye ilet"
                : dialog.kind === "receive"
                  ? "Teslimat kaydet"
                  : dialog.kind === "quality"
                    ? "Kalite sonucunu kaydet"
                    : "Siparişi iptal et"}
          </h2>
          <p className="modal-description">
            {dialog.kind === "create"
              ? "Nihai seçimi sipariş kaydına dönüştürün."
              : dialog.kind === "send"
                ? "Alıcıyı, teslimat adresini ve iletim sonucunda oluşacak durumu doğrulayın."
                : dialog.kind === "receive"
                  ? "Miktar, tarih, iade ve irsaliye bilgisini kaydedin."
                  : dialog.kind === "quality"
                    ? "Teslimatın kalite uygunluğunu denetim kaydına ekleyin."
                    : "İptal nedenini denetim kaydına ekleyin."}
          </p>
        </div>
        <button
          className="icon-button"
          aria-label="Pencereyi kapat"
          disabled={submitting}
          onClick={() => setDialog(null)}
        >
          <X size={17} />
        </button>
      </div>
      <div className="purchase-order-modal-body">
        {operationError ? (
          <div className="purchase-order-inline-error" role="alert">
            <AlertTriangle size={17} />
            <div>
              <strong>İşlem tamamlanamadı</strong>
              <span>{operationError}</span>
            </div>
          </div>
        ) : null}
        {dialog.kind === "create" ? (
          <PurchaseOrderCreateFields dialog={dialog} />
        ) : dialog.kind === "send" ? (
          <PurchaseOrderSendFields
            isRolePreview={isRolePreview}
            dispatchRecipient={dispatchRecipient}
            dialog={dialog}
            deliveryAddress={deliveryAddress}
            setDeliveryAddress={setDeliveryAddress}
          />
        ) : dialog.kind === "receive" ? (
          <PurchaseOrderReceiveFields
            dialog={dialog}
            expectedQuantity={expectedQuantity}
            setExpectedQuantity={setExpectedQuantity}
            quantity={quantity}
            setQuantity={setQuantity}
            returnQuantity={returnQuantity}
            setReturnQuantity={setReturnQuantity}
            deliveredAt={deliveredAt}
            setDeliveredAt={setDeliveredAt}
            deliveryNoteNo={deliveryNoteNo}
            setDeliveryNoteNo={setDeliveryNoteNo}
            returnDisposition={returnDisposition}
            setReturnDisposition={setReturnDisposition}
            returnReason={returnReason}
            setReturnReason={setReturnReason}
            deliveryDocument={deliveryDocument}
            chooseDeliveryDocument={chooseDeliveryDocument}
            setDeliveryDocument={setDeliveryDocument}
            note={note}
            setNote={setNote}
          />
        ) : dialog.kind === "quality" ? (
          <PurchaseOrderQualityFields
            dialog={dialog}
            qualityStatus={qualityStatus}
            setQualityStatus={setQualityStatus}
            qualityNote={qualityNote}
            setQualityNote={setQualityNote}
            qualityDisposition={qualityDisposition}
            setQualityDisposition={setQualityDisposition}
          />
        ) : (
          <PurchaseOrderCancelFields dialog={dialog} note={note} setNote={setNote} />
        )}
      </div>
      <div className="purchase-order-modal-actions">
        {submitting ? (
          <span className="purchase-order-submit-status" role="status">
            Belge doğrulanıyor ve kayıt oluşturuluyor…
          </span>
        ) : null}
        <button
          className="secondary-button"
          disabled={submitting}
          onClick={() => setDialog(null)}
        >
          Vazgeç
        </button>
        <button
          className={
            dialog.kind === "cancel" ? "danger-button" : "approve-button"
          }
          disabled={!canSubmit}
          onClick={submit}
        >
          {submitting ? (
            "Kaydediliyor…"
          ) : dialog.kind === "create" ? (
            <>
              <Check size={16} /> Sipariş taslağını oluştur
            </>
          ) : dialog.kind === "send" ? (
            <>
              <Send size={16} />{" "}
              {isRolePreview ? "Gönderimi simüle et" : "E-postayı gönder"}
            </>
          ) : dialog.kind === "receive" ? (
            <>
              <PackageCheck size={16} /> Teslimatı kaydet
            </>
          ) : dialog.kind === "quality" ? (
            <>
              <Check size={16} /> Kalite sonucunu kaydet
            </>
          ) : (
            "Siparişi iptal et"
          )}
        </button>
      </div>
    </section>
  ) : null}</>);
}
